import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Route } from "react-router-dom";
import { withAuthenticationRequired, useAuth0 } from "@auth0/auth0-react";
import { getProfile } from "api/User";
import { UserContext } from "context/user";

const PrivateRoute = ({ component: Component, layout: Layout, ...rest }) => {
  const { getAccessTokenSilently, user } = useAuth0();
  const [token, setToken] = useState(null);
  const [userProfile, setUserProfile] = useState(null);

  useEffect(() => {
    const fetchToken = async () => {
      const tokenData = await getAccessTokenSilently();
      setToken(tokenData);
    };

    fetchToken();
  }, [getAccessTokenSilently]);

  useEffect(() => {
    if (!token) return;

    const fetchUserProfile = async () => {
      const userProfileData = await getProfile(token);
      setUserProfile(userProfileData);
    };

    fetchUserProfile();
  }, [token]);

  if (!token) return null;

  return (
    <UserContext.Provider value={{ token, user, profile: userProfile }}>
      <Route
        render={(props) => (
          <Layout>
            <Component {...props} />
          </Layout>
        )}
        {...rest}
      />
    </UserContext.Provider>
  );
};

PrivateRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
  layout: PropTypes.elementType.isRequired,
};

export default withAuthenticationRequired(PrivateRoute);
